/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StatoGraduatoria } from './stato-graduatoria';


export interface GraduatoriaListItemDTO { 
    id?: string;
    nome?: string;
    stato?: StatoGraduatoria;
    calcolata_il?: string;
    creata_da?: string;
    confermata_il?: string;
    numero_righe?: number;
    stale?: boolean;
    stale_motivo?: GraduatoriaListItemDTOStaleMotivoEnum;
    graduatoria_padre_id?: string;
    version?: number;
}
export enum GraduatoriaListItemDTOStaleMotivoEnum {
    PUNTEGGI = 'PUNTEGGI',
    PADRE = 'PADRE',
    PADRE_NON_CONFERMATO = 'PADRE_NON_CONFERMATO'
};



